import React from "react";
import { FormattedMessage } from "react-intl";
import { compose } from "recompose";
import Loadable from "theme/components/helpers/Loadable";
import CmsPageSeo from "theme/modules/CmsPage/CmsPageSeo";
import WysiwygV2 from "theme/modules/WysiwygV2";
import Modal from "theme/components/organisms/Modal";
import classNames from "classnames";
import { Tracker } from "theme/helpers/CommonTrackers";
import CmsPageQuery from "theme/pages/CmsPage/CmsPageQuery.gql";
import EnhanceCmsPage from "theme/pages/CmsPage/EnhanceCmsPage";
import { withCookies } from "react-cookie";
import { SuccessAlert } from "theme/components/molecules/Alert";

const CmsPage = (props) => {
  const classes = classNames("cms-page", {
    [`cms-page--${props.cms.identifier}`]: props.cms.identifier,
    [`cms-page--with-container container`]:
      props.cms.layout !== "full" && props.cms.identifier !== "home",
    [`cms-page--no-container`]:
      props.cms.layout === "full" || props.cms.identifier === "home",
  });

  if (props.cookies.get("logged") && !props.loading) {
    setTimeout(() => {
      props.cookies.remove("logged");
    }, 10000);
  }
  return (
    <div itemScope itemType="http://schema.org/WebPage">
      {props.from}
      {props.cookies.get("logged") &&
      props.cookies.get("logged") !== "logout" ? (
        <div className="categorylogged">
          <SuccessAlert>
            <FormattedMessage
              id="pages.Login.loggedSuccess"
              defaultMessage="Your are logged in"
            />
          </SuccessAlert>
        </div>
      ) : null}
      {props.cookies.get("logged") &&
      props.cookies.get("logged") === "logout" ? (
        <div className="categorylogged">
          <SuccessAlert>
            <FormattedMessage
              id="pages.Login.logoutSuccess"
              defaultMessage="You are logged out"
            />
          </SuccessAlert>
        </div>
      ) : null}
      {typeof window !== "undefined" &&
        document.referrer.includes("sirius-bio.com") &&
        props.robertet_popup && (
          <>
            <Modal
              isOpen="true"
              children={
                <div
                  dangerouslySetInnerHTML={{
                    __html: props.sirius_popup.replace(/&quot;/gi, '"'),
                  }}
                ></div>
              }
              onRequestClose={() =>
                document
                  .querySelector("body")
                  .classList.remove("modal__body--opened")
              }
            ></Modal>
            <Tracker event="trackFromExternal" />
          </>
        )}
      <CmsPageSeo page={props.cms} />
      <div
        className={props.cms.identifier + " " + classes}
        itemProp="mainContentOfPage"
      >
        <WysiwygV2 content={props.cms.contentWysiwyg} />
      </div>
    </div>
  );
};

export default compose(
  withCookies,
  Loadable((props) => !props.loading),
  EnhanceCmsPage({ CmsPageQuery })
)(CmsPage);
